var React = require('react');

function Table (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23,4c-0.6,0-1,0.4-1,1v10h-4v-3h2v-2H4v2h2v3H2V5c0-0.6-0.4-1-1-1S0,4.4,0,5v18c0,0.6,0.4,1,1,1s1-0.4,1-1v-5h4v5  c0,0.6,0.4,1,1,1s1-0.4,1-1v-8h8v8.1c0,0.5,0.4,0.9,0.9,0.9h0.1c0.5,0,0.9-0.4,0.9-0.9V18h4v5c0,0.6,0.4,1,1,1s1-0.4,1-1V5  C24,4.4,23.6,4,23,4z M6,17H2v-1h4V17z M16,13H8v-1h8V13z M22,17h-4v-1h4V17z"}));
}

Table.defaultProps = {"enableBackground":"new 0 0 24 24","height":"24px","id":"Layer_1","version":"1.1","viewBox":"0 0 24 24","width":"24px","xmlSpace":"preserve"};

module.exports = Table;

Table.default = Table;
